import { useContext, useEffect, useState } from 'react';
import { useApiQuery } from '@water-web/api';

import { useBoolean } from '../../../hooks';
import { CookieConsentContext } from '../../../contexts';
import { CookieConsentProps } from './types';
import { SimplifiedCookieConsent } from './SimplifiedCookieConsent';
import { RegionalCookieConsent } from './RegionalCookieConsent';
import { GeolocationServiceConstructor } from '../../../apiServices';

export const CookieConsent = (props: CookieConsentProps) => {
  const consent = useContext(CookieConsentContext);
  const [showFull, setShowFull] = useState(false);
  const [renderClientSideComponent, clientSideRenderHandlers] = useBoolean(false);

  const geolocationService = GeolocationServiceConstructor();

  const { data: region, isLoading } = useApiQuery({
    endpoint: geolocationService.getUserGeolocation,
  });

  // see https://blog.hao.dev/render-client-side-only-component-in-next-js
  // for the description of the problem. using 'solution 2' here to fix
  useEffect(() => {
    clientSideRenderHandlers.turnOn();
  }, []);

  const shouldRenderConsent = consent.initialized && consent.pendingResponse && renderClientSideComponent;

  if (isLoading || !region || !shouldRenderConsent) {
    return null;
  }

  const isNorthAmerica = region === 'US' || region === 'CA';

  if (isNorthAmerica && !showFull && !consent.isManualShow) {
    return <SimplifiedCookieConsent {...props} onShowFull={() => setShowFull(true)} />;
  }

  return <RegionalCookieConsent {...props} region={region} />;
};
